import InvoiceList from '../components/Invoice/InvoiceList'; // Assuming you have this component

export default function InvoiceListPage() {
  return (
      <InvoiceList />
  );
}
